import { TextField } from "@mui/material";
import { useContext } from "react";

import { ReportsListStateContext } from "../context/reportsListProvider";

export default function Search({ setSearchState }) {
  const state = useContext(ReportsListStateContext);

  return (
    <div>
      <div className="flex items-center">
        <TextField
          className="mb-5 w-full rounded-lg text-sm placeholder:text-center"
          placeholder={"Search by report name, description"}
          size="small"
          name="reports-search"
          value={!state.search ? "" : state.search}
          InputLabelProps={{ shrink: true }}
          label="Search"
          onChange={(event) => {
            let searchVal = event.target.value;
            searchVal = searchVal.length === 0 ? "" : searchVal;
            setSearchState(searchVal);
          }}
        />
      </div>
    </div>
  );
}
